import { Route } from '@orgus/ui/icons';
import { OwnershipView } from '../../teams/OwnershipView.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'ownership',
  title: 'Ownership and routing',
  description: 'Who owns each project, and where requests for a person go.',
  order: 14,
  group: 'workspace',
  keywords: ['owners', 'routing', 'duty', 'assign'],
  icon: Route,
  Component: OwnershipView,
  needs: { module: 'teams', feature: 'Ownership and routing', instead: 'Each session still shows who started it, and approvals reach every operator.' },
};
export default section;
